import './App.css';
import Header from './components/header';
import Topics from './components/topics';
import About from './components/about';
import Prize from './components/prize';
import Footer from './components/footer';
import Faq from './components/faq';
import Timeline from './components/timeline';

function App() {
  return (
    <div className="App">
      <Header />
      <div className='app__body'>
        <About />
        <Topics />
        <Timeline />
        <Prize />
        <Faq />
        <Footer />
      </div>
    </div>
  );
}

export default App;
